import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@material-ui/core';

import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.min.css';
import FaceplateExcerpt from './FaceplateExcerpt';
import layout from '../../styles/layout.module.css';
import typography from '../../styles/typography.module.css';
import { useTranslation } from 'react-i18next';
const MobileFaceplateSection = ({ title, options }) => {
    const currency = useSelector((state) => state.shopifyReducer.ciems[0].currency);
    const { t } = useTranslation();
    const leftFaceplate = useSelector(
        (state) => state.rootReducer.currentFaceplateOption.leftOption
    );
    const rightFaceplate = useSelector(
        (state) => state.rootReducer.currentFaceplateOption.rightOption
    );
    const side = useSelector((state) => state.rootReducer.settingsOptions.currentSide);

    let additionalPrice = useMemo(() => {
        const price =
            parseFloat(options[0].price, 10) +
            parseFloat(options[0].price, 10) * process.env.REACT_APP_TAX_RATE;
        return options[0].price.localeCompare('0.00') === 1
            ? ` + ${currency}${price}${t('artwork.per_side')}`
            : '';
    }, []);

    const currentTitle = useMemo(() => {
        title = title.toLowerCase();
        const categoryTitleLeft = leftFaceplate.SK.split('#')[0].toLowerCase();
        const categoryTitlRight = rightFaceplate.SK.split('#')[0].toLowerCase();

        if (side === 'left' && categoryTitleLeft.localeCompare(title) === 0) {
            return leftFaceplate.displayName;
        } else if (side === 'right' && categoryTitlRight.localeCompare(title) === 0) {
            return rightFaceplate.displayName;
        } else if (side === 'both' && categoryTitleLeft.localeCompare(title) === 0) {
            return leftFaceplate.displayName;
        } else {
            return `${title} ${additionalPrice}`;
        }
    }, [leftFaceplate.SK, rightFaceplate.SK, side]);

    const [selected, setSelected] = useState(() => {});

    const availableOptions = options.map((element) => {
        return (
            <FaceplateExcerpt
                key={element.displayName + ' ' + element.SK}
                isCurrent={currentTitle === element.displayName}
                faceplate={element}
                setSelected={setSelected}
                selected={selected}
            />
        );
    });

    return (
        <Box
            className={layout.faceplateBtnContainer}
            style={{ height: '100%', minHeight: '200px' }}>
            <Box style={{ textAlign: 'center' }}>
                <h4 className={typography.headerTitle}>{currentTitle}</h4>
            </Box>

            <Box className={layout.sliderContainer}>{availableOptions}</Box>
        </Box>
    );
};

export default MobileFaceplateSection;
